import * as React from "react";

export type Paging = { pageNo: number; pageSize: number };

export function usePersistedPagingLocal(
  storageKey?: string,
  defaults: Paging = { pageNo: 1, pageSize: 10 }
) {
  const readInitial = React.useCallback((): Paging => {
    if (!storageKey) return defaults;
    try {
      const raw = window.sessionStorage.getItem(storageKey);
      if (raw) {
        const p = JSON.parse(raw) as Paging;
        if (p?.pageNo > 0 && p?.pageSize > 0) return p;
      }
    } catch {}
    return defaults;
  }, [storageKey, defaults.pageNo, defaults.pageSize]);

  const [paging, setPaging] = React.useState<Paging>(readInitial);

  React.useEffect(() => {
    if (!storageKey) return;
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(paging));
    } catch {}
  }, [storageKey, paging]);

  return { paging, setPaging };
}
